<template>
  <loader-full v-if="isOtpSended === null && isKdpAccepted === null" :text="'Загрузка'"/>
  <template v-else>
    <template v-if="!isKdpAccepted">
      <div v-if="isOtpSended" class="p-3 d-flex justify-content-center" style="height: 100dvh">
        <div class="col-md-6 card h-100 p-2 d-flex flex-column">
          <div class="d-flex flex-column flex-grow-1 border mb-2 overflow-auto">
            <ul class="nav nav-tabs nav-fill">
              <li class="nav-item">
                <a class="nav-link" href="#" :class="tab === 'ru' ? 'active' : ''" @click="setTab('ru')">Русский язык</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#" :class="tab === 'kz' ? 'active' : ''" @click="setTab('kz')">Казахский язык</a>
              </li>
            </ul>
            <div v-if="tab === 'ru'" class="overflow-auto p-2">
          <span>
            <div class="text-center fw-bold mb-2">Согласие на сбор и обработку персональных данных</div>
            <div class="mb-2">Я,  Субъект персональных данных даю АО «СК «Евразия», БИН 9505400002024, (далее – Страховщик), его аффилированным лицам и АО «Государственное кредитное бюро», БИН 120940011577, АО «Национальная платежная корпорация», БИН 960440000151, уполномоченным государственным органам, являющимся собственниками государственных баз данных согласие на сбор и обработку своих персональных данных, сведений, составляющих тайну страхования,  а также на передачу и получение данных в/из Единую базу данных по страхованию, в том числе, в целях получения сведений из государственных баз данных, информационных систем государственных органов и подведомственных им организаций, необходимых для получения страховых услуг и установления иных деловых отношений,  которые могут содержать (включая, но не ограничиваясь) сведения, необходимые для идентификации/аутентификации/авторизации: </div>
            <ul>
              <li>фамилия, имя, отчество (если оно указано в документе, удостоверяющем личность),</li>
              <li>гражданство,</li>
              <li>данные документа, удостоверяющего личность, зафиксированные на электронном, бумажном и (или) ином материальном носителе,</li>
              <li>биометрические данные,</li>
              <li>индивидуальный идентификационный номер,</li>
              <li>дата и место рождения,</li>
              <li>место жительства,</li>
              <li>номер телефона,</li>
              <li>адрес электронной почты,</li>
              <li>изображение,</li>
              <li>иные сведения, необходимые, для формирования документов в соответствии с требованиями законодательства Республики Казахстан.</li>
            </ul>
            <div class="mb-2">Целью сбора и обработки персональных данных является исполнение Страховщиком своих обязательств по договору страхования, установления иных деловых отношений, в том числе проведения маркетинговых мероприятий, предоставления (пересылка) Субъекту любых информационных материалов о продуктах и (или) услугах Страховщика, его аффилированных с ним лиц, а также иных уведомлений посредством телефонной, факсимильной связи, иных видов связи, а также по открытым каналам связи (в том числе sms, email, whatsapp, факс и иным средствам связи).</div>
            <div>Я даю согласие Страховщику на сбор, передачу и обработку, в том числе трансграничную своих персональных данных третьим лицам (в том числе аффилированным лицам Страховщика, профессиональным участникам страхового рынка, лицам привлекаемым Страховщиком в целях заключения, сопровождения и исполнения договора страхования и иным лицам, участвующим в рамках исполнения условий договора страхования и/или маркетинговых услуг, в т.ч. уполномоченным государственным органам, являющимся собственниками государственных баз данных.</div>
            <div>Страхователь подтверждает, что им получено согласие застрахованного, выгодоприобретателя на сбор и передачу его (их) персональных данных Страховщику и их дальнейшую обработку Страховщику, его аффилированным лицам и третьим лицам, в том числе на передачу и получение данных в/из единой страховой базы данных, иных государственных базах данных уполномоченных органов.</div>
            <div class="mb-2">Настоящее согласие выдано на срок до достижения целей, определенных Страховщиком, но не более 10 (десяти) лет и действует до момента его отзыва, если иное не предусмотрено законодательством Республики Казахстан.</div>
            <div class="mb-2">Страховщик вправе собирать (получать) персональные данные от субъекта персональных данных и любых третьих лиц, а также передавать эти персональные данные третьим лицам/распространять в общедоступных источниках персональных данных, с учетом требований действующего законодательства Республики Казахстан и требований международного права, а также проверять достоверность предоставленных персональных данных, в том числе с использованием других доступных источников.</div>
            <div class="mb-2">Настоящее согласие предоставляет право Страховщику в установленном законодательством Республики Казахстан порядке, осуществлять с персональными данными субъекта персональных данных любое действие (операцию) или совокупности таких действий (операций), в том числе, совершаемых с использованием средств автоматизации или без использования последних, включая, но не ограничиваясь, сбор, обработку, запись, копирование, резервное копирование, защиту, систематизацию, накопление, хранение с соблюдением требований безопасности и конфиденциальности, уточнение (изменение, обновление), извлечение, использование, передачу (распространение, предоставление доступа, в том числе, передачу третьим лицам с правом обработки персональных данных субъекта персональных данных, включая трансграничную передачу), обезличивание, блокирование, удаление, уничтожение.</div>
          </span>
            </div>
            <div v-if="tab === 'kz'" class="overflow-auto p-2">
              <div class="text-center fw-bold mb-2">Дербес деректерді жинауға және өңдеуге келісім</div>
              <div class="mb-2">Мен,  Дербес деректер субъектісі «Евразия» СК» АҚ, БСН 9505400002024, (бұдан әрі - Сақтандырушы), оның үлестес  тұлғаларына және «Мемлекеттік кредиттік бюро» АҚ, БСН 120940011577, «Ұлттық төлем корпорациясы» АҚ, БСН 960440000151, мемлекеттік дерекқорлардың меншік иелері болып табылатын уәкілетті мемлекеттік органдарға  өзімнің дербес деректерімді, сақтандыру құпиясын құрайтын мәліметтерді жинауға және өңдеуге, сондай-ақ деректерді Сақтандыру бойынша бірыңғай дерекқорға  беруге және алуға келісімімді беремін, оның ішінде, мемлекеттік дерекқордан, мемлекеттік органдардың және оларға ведомстволық бағынысты ұйымдардың ақпараттық жүйелерінен сақтандыру қызметтерін алу үшін қажетті мәліметтерді алу және сәйкестендіру/түпнұсқаландыру/авторландыру үшін қажетті мәліметтерді қамтуы мүмкін (қоса алғанда, бірақ онымен шектелмейтін) өзге де іскерлік қатынастарды орнату мақсатында:</div>
              <ul>
                <li>тегі, аты, әкесінің аты (егер ол жеке басын куәландыратын құжатта көрсетілсе),</li>
                <li>азаматтығы,</li>
                <li>электрондық, қағаз және (немесе) өзге де материалдық жеткізгіште тіркелген жеке басын куәландыратын құжаттың деректері,</li>
                <li>биометриялық деректер,</li>
                <li>жеке сәйкестендіру нөмірі,</li>
                <li>туған күні мен жері,</li>
                <li>тұрғылықты жері,</li>
                <li>телефон нөмірі,</li>
                <li>электрондық пошта мекенжайы,</li>
                <li>сурет,</li>
                <li>Қазақстан Республикасы заңнамасының талаптарына сәйкес құжаттарды қалыптастыру үшін қажетті өзге де мәліметтер.</li>
              </ul>
              <div class="mb-2">Дербес деректерді жинаудың және өңдеудің мақсаты Сақтандырушының сақтандыру шарты бойынша өз міндеттемелерін орындауы, өзге де іскерлік қатынастар орнатуы, оның ішінде маркетингтік іс-шаралар өткізу, Субъектіге Сақтандырушының, оның үлестес  тұлғаларының өнімдері және (немесе) қызметтері туралы кез келген ақпараттық материалдарды, сондай-ақ телефон, факсимильді байланыс, байланыстың өзге де түрлері арқылы, сондай-ақ байланыстың ашық арналары арқылы өзге де хабарламаларды жіберу (оның ішінде sms, email, whatsapp, факс және өзге де байланыс құралдары) болып табылады.</div>
              <div>Мен Сақтандырушыға өзімнің дербес деректерімді жинауға, үшінші тұлғаларға (оның ішінде Сақтандырушының үлестес  тұлғаларына, сақтандыру нарығының кәсіби қатысушыларына, сақтандыру шартын жасау, сүйемелдеу және орындау мақсатында Сақтандырушы тартатын тұлғаларға және сақтандыру және/немесе маркетингтік қызметтер көрсету шартының шарттарын орындау аясында  қатысатын өзге де тұлғаларға, оның ішінде мемлекеттік дерекқордың меншік иелері болып табылатын уәкілетті мемлекеттік органдарға) беруге және өңдеуге келісім беремін.</div>
              <div>Сақтанушы сақтандырылушының, пайда алушының оның (олардың) дербес деректерін Сақтандырушыға беруге және оларды Сақтандырушыға, оның үлестес  тұлғаларына және үшінші тұлғаларға одан әрі өңдеуге, оның ішінде деректерді бірыңғай сақтандыру дерекқорына, уәкілетті органдардың өзге де мемлекеттік дерекқорларына беруге және алуға келісімін алғанын растайды.</div>
              <div class="mb-2">Осы келісім Сақтандырушы айқындаған мақсаттарға қол жеткізгенге дейін, бірақ 10 (он) жылдан аспайтын мерзімге берілді және, егер Қазақстан Республикасының заңнамасында өзгеше көзделмесе, оны қайтарып алу сәтіне дейін қолданылады.</div>
              <div class="mb-2">Сақтандырушы дербес деректер субъектісінен және кез келген үшінші тұлғалардан дербес деректерді жинауға (алуға), сондай-ақ осы дербес деректерді үшінші тұлғаларға беруге/Қазақстан Республикасының қолданыстағы заңнамасының талаптарын және халықаралық құқық талаптарын ескере отырып, дербес деректердің жалпыға бірдей қолжетімді көздерінде таратуға, сондай-ақ ұсынылған дербес деректердің дұрыстығын, оның ішінде басқа қолжетімді көздерді пайдалана отырып тексеруге құқылы.</div>
              <div class="mb-2">Осы келісім Сақтандырушыға Қазақстан Республикасының заңнамасында белгіленген тәртіппен дербес деректер субъектісінің дербес деректерімен кез келген әрекетті (операцияны) немесе осындай әрекеттердің (операциялардың) жиынтығын, оның ішінде автоматтандыру құралдарын пайдалана отырып немесе соңғыларын пайдаланбай жүзеге асыру, қауіпсіздік пен құпиялылық талаптарын сақтай отырып, жинауды, өңдеуді, жазуды, көшіруді, резервтік көшіруді, қорғауды, жүйелеуді, жинақтауды, сақтауды, нақтылауды (өзгертуді, жаңартуды), алуды, пайдалануды, беруді (таратуды, қол жеткізуге рұқсат беруді, оның ішінде трансшекаралық беруді қоса алғанда, дербес деректер субъектісінің дербес деректерін өңдеу құқығымен үшінші тұлғаларға беруді) қоса алғанда, бірақ олармен шектелмей, иесіздендіру, бұғаттау, алып тастау, жою құқығын береді.</div>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-end">
            <div class="mb-2 px-2 text-primary text-center" @click="downloadDocument">Скачать документ "Согласие на сбор и обработку персональных данных"</div>
            <InputField
                v-model="code"
                id="code"
                name="code"
                :required="true"
                :mb="5"
                placeholder="Код"
                type="text"
            />
            <button class="btn btn-primary w-100" @click="sendCode">
          <span>
            <span class="indicator-progress" aria-hidden="true">
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
            <span class="indicator-label">Подтвердить</span>
          </span>
            </button>
          </div>
        </div>
      </div>
      <div v-else class="p-3 d-flex justify-content-center" style="height: 100dvh">
        <div class="col-12 col-md-6 card p-3 justify-content-center align-items-center">
          <i class="ki-duotone ki-cross fs-6x text-danger mb-5">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <h2>У вас нет доступа</h2>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="p-3 d-flex justify-content-center" style="height: 100dvh">
        <div class="col-12 col-md-6 card p-3 justify-content-center align-items-center">
          <i class="ki-duotone ki-check-circle fs-6x text-primary mb-5">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <h2>Согласие предоставлено</h2>
        </div>
      </div>
    </template>
  </template>
  <notifications position="top right" :pauseOnHover="true"/>
</template>

<script>
import axios from 'axios'
import InputField from "@/components/Fields/InputField.vue";
import states from "@/helpers/states";
import LoaderFull from "@/components/Main/LoaderFull.vue";
import crypto from "@/helpers/crypto";
export default {
  name: 'KdpAgree',
  components: {LoaderFull, InputField},
  data() {
    return {
      isOtpSended: null,
      isKdpAccepted: null,
      iin: this.$route.params.iin,
      code: this.$route.query.code,
      tab: 'ru'
    }
  },
  mounted() {
    this.checkStatus()
  },
  methods: {
    setTab(tab) {
      this.tab = tab
    },
    downloadDocument() {
      const domain = states.getBackEndUrlByState();
      window.open(domain + 'api/kdp/get-document', '_blank')
    },
    checkStatus() {
      axios.get('api/kdp/check-status', {params: {iin: this.iin}}).then(res => {
        let data = JSON.parse(crypto.decryptBackend(res.data))
        this.isOtpSended = data.isOtpSended
        this.isKdpAccepted = data.isKdpAccepted
      })
    },
    sendCode() {
      axios.post('api/kdp/accept', {code: this.code, iin: this.iin}).then(res => {
        if (res.data.result) {
          this.isKdpAccepted = true
        } else {
          this.$notifyError(res.data)
        }
      }).catch(err => {
        this.$notifyError(err)
      })
    }
  }
}
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.overflow-auto {
  max-height: calc(100% - 4rem);
  overflow-y: auto;
}

.btn {
  margin-top: auto;
}
</style>